import { useMutation } from "@tanstack/react-query";
import { MutationBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import { AxiosResponse } from "axios";
import { Axios } from "../../../Axios";
import Boleto from "../../../../Models/Financeiro/Titulo/Pagamento/Boleto";

export function useBoletoGerarLoteRemessa({
    ...rest
}:MutationBasicaParam<{
    codConta: number,
    titulos: number[]
}, AxiosResponse<Blob>>) {
    return useMutation({
        ...rest,
        mutationFn: (data) => Axios.post<Blob>("financeiro/titulo/pagamento/boleto/remessa/lote", data, {
            responseType: "blob",
            //transformResponse: (config) => {
            //    console.log("Config: ", config);
            //    //const [data, headers, statusCode] = config.data;

            //    //console.log("Boleto: ", new Blob([new Uint8Array(data.buffer, data.byteOffset, data.byteLength)]));
            //    //if (statusCode === 200) return new Blob([new Uint8Array(data.buffer, data.byteOffset, data.byteLength)]);

            //    return rest;
            //}
        })
    });
}

export function useProcessarRetorno({
    ...rest
}: MutationBasicaParam<
    { codConta:number, arquivo: File },
    AxiosResponse<void>
>) {
    return useMutation({
        ...rest,
        mutationFn : (data) => {       
            const formData = new FormData();

            // formData.append("codConta", data.codConta.toString());
            formData.append("retorno", data.arquivo);

            const opcoes = {
                headers : {
                    "Content-Type" : "multipart/form-data"
                }
            };

            return Axios.post<void>(`financeiro/titulo/pagamento/boleto/conta/${data.codConta}/processar-retorno`, formData, opcoes);
        }
    });
}

export function useObterLinkBoleto({
    onSuccess,
    ...rest
}:MutationBasicaParam<Boleto, string>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios
                .post(`financeiro/titulo/pagamento/boleto/link/gerar/conta/${dataRequest.codConta}/titulo/${dataRequest.codTitulo}`)
                .then(r => `${Axios.defaults.baseURL}/financeiro/titulo/pagamento/Boleto/imprimir?${r.data}`)
            ;
        },
        onSuccess : (retorno, entrada, context) => {
            onSuccess?.(retorno, entrada, context);
        }
    });
}